import React, { useState } from 'react';
import TagManager from 'react-gtm-module';
import PropTypes from 'prop-types';
import API from 'api';
import ActivationCodeField from 'components/pages/SignIn/Widgets/ActivationCodeField';
import EmailField from 'components/pages/SignIn/Widgets/EmailField';
import ActionButton from 'components/Common/ActionButton';
import Steps from '../steps';
import Styles from './index.module.css';

export default function ActivationForm({ onChangeStep }) {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');

  const handleActivateAccount = async () => {
    const result = await API.auth.activateAccount(email, code);
    if (result.error) {
      alert(result.error.errorMsg);
      return result.error;
    }
    TagManager.dataLayer({
      dataLayer: {
        event: 'userRegist',
      },
    });
    onChangeStep(Steps.Login);
    return null;
  };

  return (
    <div className={Styles.container}>
      <div className={Styles.title}>
        驗證帳號
      </div>
      <div className={Styles.subtitle}>
        請至您註冊的信箱接收驗證碼，再返回此頁面完成驗證
      </div>
      <EmailField value={email} onChange={(e) => setEmail(e.target.value)} />
      <ActivationCodeField value={code} onChange={(e) => setCode(e.target.value)} />
      <div className={Styles.resetButtonContainer}>
        <ActionButton style={{ width: '100%', maxWidth: 280, color: '#FFFFFF' }} onClick={handleActivateAccount}>
          驗證
        </ActionButton>
      </div>
    </div>

  );
}

ActivationForm.propTypes = {
  onChangeStep: PropTypes.func,
};

ActivationForm.defaultProps = {
  onChangeStep: () => {},
};
